import { _ as ai } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.symbol.description-6025a604.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.map-d821aaf5.js";
import "./es.date.to-json-b76d522e.js";
import "./es.object.assign-7e79fd7b.js";
import { useRef as ui, useState as P, useEffect as H, createElement as si } from "react";
import "./es.array.filter-4e9c9996.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as A } from "./getMetrics-953aa4f8.js";
import { Chip as di, ChipGroup as V } from "./chip.js";
import { _ as u } from "./index-f5b44da3.js";
import "./es.object.keys-9d66766f.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import "./web.set-timeout-72b6430f.js";
import { uniqueId as ci } from "./uniqueId.js";
import { jsxs as S, jsx as l } from "react/jsx-runtime";
import { _ as J } from "./objectDestructuringEmpty-69c165c0.js";
import c, { css as v } from "styled-components";
import "@ucl/shared-component-foundations";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import { useSlots as K } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./index-8b07dec9.js";
import "./index-5d0f31c6.js";
import "./export-cdcbfb2b.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./iterate-13ada9e5.js";
import "./array-iteration-759bfbfa.js";
import "./function-apply-4756dee6.js";
import "./create-property-f9780ed1.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./array-method-is-strict-e5a3c878.js";
import "./aria.js";
import "./closeButton.js";
import "./iconButton.js";
import "./button.js";
import "./combineRefs-c9ad2c39.js";
import "./environment-ddee5959.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-icons";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./badge.js";
import "./es.date.to-string-6ed49878.js";
import "./es.string.small-23219181.js";
import "./string-html-forced-a746405b.js";
import "./useWindowSize.js";
import "./modalWindow.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./useClient.js";
import "./disclosure.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.from-fe752fa6.js";
import "./es.array.index-of-084b82ab.js";
import "./useOnClickOutside.js";
import "./index-55eee02a.js";
import "./tslib.es6-59e1c9d8.js";
import "./hooks_internal.js";
import "./analytics.js";
import "./es.string.search-d27ec57a.js";
import "./es.string.trim-6e13db75.js";
import "./string-trim-14e37ad3.js";
import "./es.function.bind-b4bdcd4b.js";
import "./es.function.name-b230e7d4.js";
import "@ucl/ucl-translation";
import "./helperText.js";
import "./image.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./mediaDisclosureButton.js";
import "./es.parse-int-d7709701.js";
import "./label.js";
import "./popupTip-06ee114c.js";
import "./divider.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import "./tooltip.js";
import "./carousel.js";
import "./useMediaQuery.js";
import "./index-f2264f1e.js";
import "./screenReaderOnly.js";
import "./accessibility.js";
import "./text.js";
import "./cloneSlots-622cf8c9.js";
import "./link.js";
import "./es.global-this-a7f40ce1.js";
var vi = ["children", "menuLists", "menuHeader", "value", "onChange", "leadingIcon", "isRadio", "isCloseOnSelect", "isDisabled", "menuDirection", "exceedOverflow", "onBlur", "handleMenuOpen", "menuOpen", "menuWidth", "noResultText"], k = function(i) {
  var e = i.children, n = i.menuLists, t = n === void 0 ? [] : n, h = i.menuHeader, G = i.value, f = G === void 0 ? [] : G, y = i.onChange, Q = i.leadingIcon, w = i.isRadio, C = w === void 0 ? !1 : w, j = i.isCloseOnSelect, U = j === void 0 ? !1 : j, M = i.isDisabled, X = i.menuDirection, x = i.exceedOverflow, Y = x === void 0 ? !1 : x, Z = i.onBlur, I = i.handleMenuOpen, $ = i.menuOpen, D = $ === void 0 ? !1 : $, R = i.menuWidth, ii = R === void 0 ? "280px" : R, ti = i.noResultText, ri = ai(i, vi), ei = A({
    label: "Filter"
  }), g = ui(ci("filter")), T = P(!1), O = T[0], E = T[1], _ = P(f), s = _[0], q = _[1];
  H(function() {
    q(f);
  }, [JSON.stringify(f)]), H(function() {
    E(D);
  }, [D]);
  var oi = function(o, m) {
    var p = C ? [m == null ? void 0 : m.value] : m.map(function(a) {
      return a == null ? void 0 : a.value;
    });
    q(p), y && y(o, {
      label: e,
      values: p,
      isActive: !!p.length
    });
  }, ni = function(o) {
    return o == null ? void 0 : o.map(function(m, p) {
      var a = m.title, pi = m.items;
      return [a && /* @__PURE__ */ l(u.Title, {
        children: a
      }, "title-" + p), pi.map(function(d) {
        var L = d.label, N = d.value, b = N === void 0 ? L : N, W = d.description, mi = W === void 0 ? "" : W, B = d.trailingElement, li = B === void 0 ? "" : B;
        return /* @__PURE__ */ l(u.Item, {
          label: L,
          value: b,
          description: mi,
          trailingElement: li,
          isSelected: s.includes(b)
        }, b);
      }), p !== o.length - 1 && /* @__PURE__ */ l(u.Divider, {}, "divider-" + p)];
    });
  };
  return /* @__PURE__ */ S(u, Object.assign({
    menuOpen: O,
    handleMenuOpen: function(o) {
      I == null || I(o), E(o);
    },
    menuHeader: h,
    onChange: oi,
    menuDirection: X,
    type: C ? "radio" : "multiple",
    isDisabled: M,
    closeOnSelect: U,
    exceedOverflow: Y,
    uniqueIdentifier: "" + g.current,
    menuWidth: ii,
    noResultText: ti
  }, ei, {
    children: [/* @__PURE__ */ l(u.Control, {
      children: /* @__PURE__ */ l(di, Object.assign({
        id: "control-" + g.current,
        badgeProps: {
          value: "" + (s.length > 0 ? s.length : ""),
          size: "small",
          type: "primary",
          emphasis: "high"
        },
        leadingIcon: Q,
        isRadio: C,
        isActive: s.length > 0,
        isDisabled: M,
        onClick: Z,
        isOpen: O,
        "aria-expanded": O,
        "aria-controls": "control-" + g.current
      }, ri, {
        variant: "filter",
        children: e
      }))
    }), ni(t)]
  }));
}, hi = /* @__PURE__ */ c.div.withConfig({
  displayName: "filterGroup__StyledFilterContainer",
  componentId: "wjw9zb-0"
})(["", ";"], function(r) {
  var i = r.theme.components.filter;
  return v(i.FilterContainer);
}), fi = /* @__PURE__ */ c.div.withConfig({
  displayName: "filterGroup__StyledChipGroupContainer",
  componentId: "wjw9zb-1"
})(["", ";"], function(r) {
  var i = r.theme.components.filter;
  return v(i.ChipGroupContainer);
}), Ci = /* @__PURE__ */ c.div.withConfig({
  displayName: "filterGroup__StyledFilterGroup",
  componentId: "wjw9zb-2"
})(["", ";"], function(r) {
  var i = r.theme.components.filter;
  return v(i.FilterGroup);
}), Tr = /* @__PURE__ */ c.div.withConfig({
  displayName: "filterGroup__StyledTableFilterGroup",
  componentId: "wjw9zb-3"
})(["", ";"], function(r) {
  var i = r.theme.components.filter;
  return v(i.TableFilterContainer);
}), gi = function(i) {
  var e = Object.assign({}, (J(i), i)), n = K(e.children, {
    Filters: k
  });
  return /* @__PURE__ */ S(Ci, Object.assign({}, e, {
    children: [n.Filters.map(function(t, h) {
      return /* @__PURE__ */ si(k, Object.assign({}, t == null ? void 0 : t.props, {
        onChange: (t == null ? void 0 : t.props.onChange) || function() {
          return "";
        },
        key: "filter" + h
      }), String(t == null ? void 0 : t.props.children) || "");
    }), n.rest]
  }));
}, F = function(i) {
  var e = Object.assign({}, (J(i), i)), n = A({
    label: "FilterGroup"
  }), t = K(e.children, {
    Container: F.Container,
    ChipGroup: V
  });
  return /* @__PURE__ */ S(hi, Object.assign({}, e, n, {
    children: [t.Container, t.ChipGroup.length > 0 && /* @__PURE__ */ l(fi, {
      children: t.ChipGroup
    })]
  }));
};
F.Container = gi;
F.ChipGroup = V;
export {
  k as Filter,
  F as FilterGroup,
  gi as FiltersContainer,
  fi as StyledChipGroupContainer,
  hi as StyledFilterContainer,
  Ci as StyledFilterGroup,
  Tr as StyledTableFilterGroup
};
